export const AlertType = {
  Info: 'info',
  Error: 'error',
  Warning: 'warning',
  Success: 'success',
};

export const OrderStatus = {
  ON_TIME: 'on-time',
  DUE_SOON: 'due-soon',
  LATE: 'late',
  PAUSED: 'paused',
  DONE: 'done',
  NOT_APPLICABLE: 'n/a',
  MECHANICAL: 'mechanical',
  IN_PROCESS: 'in-process',
  WHOLE_SALE: 'wholesale',
};

export const ProcessStep = {
  GENERATED: 'Generated',
  APPROVED: 'Approved',
  IN_TRANSIT: 'In Transit',
  ARRIVED: 'Arrived',
  IN_PROCESS: 'In Process',
  DONE: 'Done',
  CANCELED: 'Canceled',
  TRANSFERRED: 'Transferred',
  DECLINED: 'Declined',
  PAUSED: 'Paused',
  PENDING_APPROVAL: 'Pending Approval',
  MECHANICAL: 'Mechanical',
  WHOLE_SALE: 'Wholesale',
};

export const OrderTypes = {
  WORK_ORDER: 'work_order',
  RECONDITIONING: 'reconditioning',
  ESTIMATE: 'estimate',
  ALL: 'All',
  SERVICE_ORDER: 'service_order',
};

export const ProcessStepSubCategories = {
  RESTORED: 'isComingFromRestoreModal',
  RESTORED_IN_PROCESS: 'Restored (In Process)',
  IN_TRANSIT_PAUSED: 'In Transit (Paused)',
};

export const StaticFilters = {
  TO_DO: { column: 'step', value: 'Done', operator: 'ne' },
  DONE: { column: 'step', value: 'Done', operator: 'eq' },
  INVOICES_UNBILLED: [
    { column: 'step', value: 'Done', operator: 'eq' },
    { column: 'isBilled', value: 'false', operator: 'eq' },
  ],
  INVOICES_TODO: { column: 'status', value: 'FULLY_PAID', operator: 'lt' },
};

export const BackEndTableKeys = {
  STOCK: 'stock_number',
  VIN: 'vin_number',
  PO: 'dealer_purchase_order_number',
  RO: 'repair_order',
  STATUS: 'status',
};

export const CompanyStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

export const EndPoints = {
  VENDORS: {
    ORDERS: {
      MODIFY: {
        ENDPOINT: '/orders/',
        PROXY: ':order_id',
        TYPE: 'patch',
      },
      VENDORMODIFY: {
        ENDPOINT: '/orders/vendors/',
        PROXY: ':vendor_order_id',
        TYPE: 'patch',
      },
      SEARCH: ['/orders/search', 'post'],
    },
    VEHICLE: {
      MODIFY: {
        ENDPOINT: '/vehicles/',
        PROXY: ':vehicle_id',
        TYPE: 'patch',
      },
      CUSTODYMODIFY: {
        ENDPOINT: '/vehicles/custodies/',
        PROXY: ':custody_id',
        TYPE: 'patch',
      },
    },
  },
  ACCOUNTING: {
    STORES: ['/accounting/stores', 'post'],
    INVOICES_SEARCH: ['/invoices/search', 'post'],
    INVOICES_PATCH: {
      ENDPOINT: '/invoices/:invoice_id',
      TYPE: 'patch',
    },
  },
};

export const UserRoles = {
  DEALERSHIP_EMPLOYEE: 'Dealership Employee',
  DEALERSHIP_MANAGER: 'Dealership Manager',
  DEALERSHIP_MULTISITE_LEADER: 'Dealership Multisite Leader',
  DEALERSHIP_BILLING: 'Dealership Billing',
  VENDOR_EMPLOYEE: 'Vendor Employee',
  VENDOR_STORE_MANAGER: 'Vendor Store Manager',
  VENDOR_MULTISITE_LEADER: 'Vendor Multisite Leader',
  VENDOR_BILLING: 'Vendor Billing',
};

export const Platform = {
  ACCOUNTING: 'accounting',
  STORE: 'store',
};

export const Order = {
  ASC: 'asc',
  DESC: 'desc',
};

export const AccountingOrderBy = {
  UNBILLED: 'unbilled',
  UNPAID: 'unpaid',
  STORE_NUMBER: 'storeNumber',
};

export const InvoiceStatus = {
  UNAPPROVED: 'UNAPPROVED',
  APPROVED: 'APPROVED',
  SENT: 'SENT',
  CANCELED: 'CANCELED',
  PARTIALLY_PAID: 'PARTIALLY_PAID',
  FULLY_PAID: 'FULLY_PAID',
};

export const PaymentStatusEnum = {
  PARTIALLY_PAID: 'Partially Paid',
  NOT_PAID: 'Not paid',
  PAID: 'Paid',
};

export const StatusCode = {
  SUCCESS: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  NOT_IMPLEMENTED: 501,
};

export const WOQuality = {
  BELOW: 'below',
  MEETS: 'meets',
  ABOVE: 'above',
};

export const NotificationTypes = {
  ORDER_APPROVAL: 'ORDER_APPROVAL',
  ORDER_EDITED: 'ORDER_EDITED',
  ORDER_DECLINED: 'ORDER_DECLINED',
  ORDER_COMPLETED: 'ORDER_COMPLETED',
  ORDER_CREATED_BY_DEALER: 'ORDER_CREATED_BY_DEALER',
  ORDER_APPROVED_BY_DEALER: 'ORDER_APPROVED_BY_DEALER',
  NEGATIVE_QUALITY_SURVEY: 'NEGATIVE_QUALITY_SURVEY',
  LATE_STORE_OPENING: 'LATE_STORE_OPENING',
  ESTIMATE_APPROVAL: 'ESTIMATE_APPROVAL',
};

export const WOErrorTokens = {
  UNEXPECTED_ERROR: 'UNEXPECTED_ERROR',
  SERVICE_LIMIT_EXCEEDED: 'SERVICE_LIMIT_EXCEEDED',
  DEPENDENT_PARENT_REQUIRED: 'DEPENDENT_PARENT_REQUIRED',
};

export const OrderPriority = {
  NA: 'N/A',
  VERY_LOW: 'Very Low',
  LOW: 'Low',
  MEDIUM_LOW: 'Medium Low',
  MEDIUM: 'Medium',
  MEDIUM_HIGH: 'Medium High',
  HIGH: 'High',
  VERY_HIGH: 'Very High',
  HIGHEST: 'Highest',
};

export const WOSTATUS = {
  ALL: 'All',
  IN_TRANSIT: 'In transit',
  IN_PROCESS: 'In process',
};

export const WONumberPrefixes = {
  ESTIMATES: 'ES',
  PACKAGES: 'PA',
  SIMPLE_ORDER: 'WO',
  SERVICE_ORDER: 'SO',
  DEFAULT: 'WO',
};
